import React from 'react';
import { Main } from './ErrorLayout.styles';

const ErrorLayout: React.FC<ChildrenProps> = ({ children }) => {
    return <Main>{children}</Main>;
};

export default ErrorLayout;
